<div class="flex gap-2">
  <button
    mat-stroked-button
    *ngIf="showViewFormBtn"
    [matTooltip]="viewLabel"
    (click)="onViewForm()"
    class="cancel">
    <span>{{ viewLabel }}</span>
    <mat-icon
      iconPositionStart
      matButtonIcon
      svgIcon="mat:remove_red_eye"></mat-icon>
  </button>
  <button
    mat-stroked-button
    *ngIf="showDownloadFormBtn"
    [matTooltip]="downloadLabel"
    (click)="onDownloadForm()"
    class="cancel">
    <span>{{ downloadLabel }}</span>
    <mat-icon iconPositionStart matButtonIcon svgIcon="mat:download"></mat-icon>
  </button>
</div>
